import {useMutation, useQueryClient} from 'react-query';
import {useTranslation} from 'react-i18next';

import api from 'utils/api';
import {setAlert, setSuccessAlert} from 'actions/alerts';
import userProfileKeys from './queryKeys';

async function updateUserProfile(settings) {
	return api('put', '/api/me/profile', null, settings);
}

function useUpdateUserProfile() {
	const {t} = useTranslation();
	const queryClient = useQueryClient();

	const {isLoading, isError, mutateAsync} = useMutation(updateUserProfile, {
		onSuccess: () => {
			queryClient.invalidateQueries(userProfileKeys.userProfile);
			setSuccessAlert({
				title: t('alert_profile_updated_msg'),
			});
		},

		onError: err => {
			setAlert({
				title: t('alert_profile_not_updated_msg'),
				message: err?.error,
			});
		},
	});

	return {isLoading, isError, updateUserProfile: mutateAsync};
}

export default useUpdateUserProfile;
